<template lang="pug">
  google-search-box
</template>

<script>
import GoogleSearchBox from 'COMPONENTS/BaseGoogleSearch'

export default {

  components: {
    GoogleSearchBox
  }

}
</script>



// WEBPACK FOOTER //
// GoogleSearch.vue?02195f45